module.exports = __webpack_public_path__ + "static/media/SoftwareTopology.29ea0e87.jpg";